import { ChevronRight } from '@vfit/shared-icons';
import Link from 'next/link';
import { IAnchorBox } from './anchorBox.models';
import { AnchorBoxContainer, AnchorLabel, Container } from './anchorBox.style';

const AnchorBox = ({ isDarkMode, anchorLabel, anchorLink }: IAnchorBox) => (
  <AnchorBoxContainer>
    <Link href={anchorLink}>
      <Container className="anchorBox-link" darkMode={isDarkMode}>
        <AnchorLabel>{anchorLabel}</AnchorLabel>
        <ChevronRight />
      </Container>
    </Link>
  </AnchorBoxContainer>
);

export default AnchorBox;
